import { O2SheetComponent } from './lib/o2-sheet.component';
import { O2SheetHeaderDirective } from './lib/o2-sheet-header.directive';
import { O2SheetBodyDirective } from './lib/o2-sheet-body.directive';
import { O2SheetFooterDirective } from './lib/o2-sheet-footer.directive';
import { O2SheetTitleDirective } from './lib/o2-sheet-title.directive';

export * from './lib/o2-sheet.component';
export * from './lib/o2-sheet-header.directive';
export * from './lib/o2-sheet-body.directive';
export * from './lib/o2-sheet-footer.directive';
export * from './lib/o2-sheet-title.directive';

/**
 * O2 Sheet Imports
 *
 * Import this array to use the O2 Sheet component and directives.
 * Includes:
 * - O2SheetComponent: Main sheet container
 * - O2SheetHeaderDirective: Header section styling
 * - O2SheetBodyDirective: Scrollable body styling
 * - O2SheetFooterDirective: Footer section styling
 * - O2SheetTitleDirective: Title styling
 *
 * Usage:
 * @Component({
 *   imports: [O2SheetImports, ...]
 * })
 *
 * Example:
 * <o2-sheet side="right">
 *   <div o2SheetHeader>
 *     <h2 o2SheetTitle>{{ title() }}</h2>
 *   </div>
 *   <div o2SheetBody>
 *     <form>...</form>
 *   </div>
 *   <div o2SheetFooter>
 *     <button>Save</button>
 *   </div>
 * </o2-sheet>
 */
export const O2SheetImports = [
  O2SheetComponent,
  O2SheetHeaderDirective,
  O2SheetBodyDirective,
  O2SheetFooterDirective,
  O2SheetTitleDirective,
] as const;
